import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_CONSULT_TYPES } from "api/Service";

export const CONSULT_TYPES_QUERY_KEY = "consultTypes";

export const useConsultTypes = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [CONSULT_TYPES_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_CONSULT_TYPES}`
      );

      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
